import React, { useState } from 'react';
import { CoinsIcon } from 'lucide-react';
export function PokePoints({
  points
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };
  return <div onClick={toggleExpanded} className={`fixed top-4 right-4 z-40 text-white shadow-lg flex items-center cursor-pointer transition-all duration-300 ease-in-out ${isExpanded ? 'bg-yellow-500 px-3 py-1 rounded-full' : 'w-10 h-10 rounded-full flex items-center justify-center'}`} data-id="element-335">
      {isExpanded ? <>
          <CoinsIcon className="w-4 h-4 mr-1" data-id="element-336" />
          <span className="font-bold" data-id="element-337">{points} PokéPoints</span>
        </> : <div className="relative w-10 h-10 flex items-center justify-center" data-id="element-338">
          {/* Pokeball design */}
          <div className="absolute inset-0 rounded-full bg-white border-2 border-black" data-id="element-339"></div>
          <div className="absolute inset-0 rounded-full bg-red-600 border-2 border-black" style={{
        clipPath: 'polygon(0 0, 100% 0, 100% 50%, 0 50%)'
      }} data-id="element-340"></div>
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-341">
            <div className="w-3 h-3 bg-white rounded-full border border-black z-10" data-id="element-342"></div>
          </div>
        </div>}
    </div>;
}